import { mapActions } from "vuex";
import moment from "moment";
import tableColumnDecrypt from "@/components/table-column-decrypt";
import { decrypt } from "@/api/util";
export default {
    name: "auth",
    components: {
        tableColumnDecrypt
    },
    data() {
        return {
			isMultiTenant:false,
			tenantNameText:null,
            filterMenuIds:[],
            show: {
                Org: false,
                User: false,
                Role: false,
                Role_Query: false,
                Role_Add: false,
                Role_Del: false,
                Role_Update: false,
                Role_State: false,
                Role_Look: false,
                Org_Add: false,
                Org_Del: false,
                Org_Update: false,
                Org_Add_User: false,
                Org_Del_User: false,
                User_Add: false,
                User_Del: false,
                User_Update: false,
                User_State: false,
                User_Query: false,
                User_Look: false
            },
            orgHeight: this.$store.state.viewHeight - 120,
            empHeight: this.$store.state.viewHeight - 160,
            roleHeight: this.$store.state.viewHeight - 150,
            activeTab: null,
            defaultProps: {
                children: "children",
                label: "label",
            },
            companyName: "未来运力科技有限公司",
            currentPage1: 1,
            currentPage2: 1,
            userForm: {},
            roleForm: {
                name: "",
                status: "1",
            },
            newOrgDialogFormVisible: false,
            newOrgDialogForm: {},
            newOrgDialogFormRules: {
                name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
            },
            addMemDialogFormVisible: false,
            searchKey: "",
            newMemDialogFormVisible: false,
            alterMemDialogFormVisible: false,
            newMemDialogForm: {},
            newMemDialogFormRules: {
                name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
            },
            newRoleDialogFormVisible: false,
            newRoleDialogForm: {},
            newRoleDialogFormRules: {
                name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
            },
            employeeDetailsDialogVisible: false,

            employeeDtlLogData: [],
            roleLogData: [],
            roleDetailsDialogVisible: false,
            organize: {
                filterText: '',
                treeData: [],
                tableData: [],
                multipleSelection: [],
                pageSize: 10,
                pageNum: 1,
                total: 0,
                currOrgId: '',
                neworg: {
                    title: '新增组织',
                    form: {
                        orgName: '',
                        orgType: '1',
                        parentId: '',
                        num: '',
                    },
                    rules: {
                        orgName: [
                            { required: true, message: '请输入组织名称', trigger: 'blur' }
                        ],
                        orgType: [
                            { required: true, message: '请选择组织类型', trigger: 'change' }
                        ],
                        parentId: [
                            { required: true, message: '请输入上级组织', trigger: 'blur' }
                        ],
                        /* num:[
                            {required: false, type: 'number', message: '排序必须为数字',trigger: 'blur'}
                        ] */
                    }
                },
                emp: {
                    form: {
                        key: '',
                        pageSize: 10,
                        pageNum: 1,
                    },
                    tableData: [],
                    multipleSelection: [],
                    totalCount: 0,
                },

            },
            employee: {
                form: {
                    userName: "",
                    telephone: "",
                    identity: "",
                    roleName: "",
                    state: null,
                    orgName: "",
                    pageSize: 10,
                    pageNum: 1,
                },
                tableData: [],
                multipleSelection: [],
                totalCount: 0,
                details: {
                    name: "",
                    phone: "",
                    certId: "",
                    role: "",
                    org: "",
                    power: "",
                    state: "",
                    createTime: "",
                },
                news: {
                    title: '新增员工',
                    currUserId: '',
                    form: {
                        userName: '',
                        telephone: '',
                        identity: '',
                        roleStr: '',
                        orgStr: '',
                        powerStr: '',
                        roleIdList: [],
                        orgIdList: [],
                        powerList: []
                    },
                    rules: {
                        userName: [
                            { required: true, message: '请输入员工姓名', trigger: 'blur' },
                        ],
                        telephone: [
                            { required: true, message: '请输入联系电话', trigger: 'blur' },
                        ],
                        identity: [
                            { required: true, message: '请输入身份证号', trigger: 'blur' },
                        ],
                    },
                    orgVisible: false,
                    roleVisible: false,
                    powerVisible: false,
                    tree: {
                        data: [],
                        defaultProps: {
                            children: 'children',
                            label: 'label'
                        },
                        data_right: [],
                        powerTree: [],
                    },
                    checkbox: {
                        options: [],
                        checkeds: [],
                    },
                    pCheckbox: {
                        options: [],
                        checkeds: [],
                    }
                },


            },
            role: {
                form: {
                    roleName: '',
                    state: ''
                },
                treeData: [],
                props: {
                    children: "children",
                    label: "menuName",
                },
                tableData: [],
                multipleSelection: [],
                pageSize: 10,
                pageNum: 1,
                total: 0,
                newRole: {
                    roleId: '',
                    title: '新增角色',
                    form: {
                        roleName: '',
                        menuList: []
                    },
                    rules: {
                        roleName: [
                            { required: true, message: '请输入角色名称' }
                        ]
                    },

                },
                details: {
                    roleId: null,
                    treeData: [],
                    tableData: [],
                    pageSize: 20,
                    pageNum: 1,
                    totalCount: 0
                }
            }
        };
    },

    methods: {
        ...mapActions([
            "getEmployeeListApi",
            "alterEmployInfoApi",
            "createEmployeeApi",
            "getRoleListApi",
            "getRoleListSummaryApi",
            "getOrgTreeApi",
            "getPowerTreeApi",
            "removeEmployeesApi",
            "enableMemberApi",
            "disableMemberApi",
            "getOrgQueryMembersApi",
            "getOrgExMemberApi",
            "createOrgApi",
            "updateOrgApi",
            "removeMembersApi",
            "addMemsToOrgApi",
            "removeOrgApi",
            "deleteRoleApi",
            "queryMenuTreeDefaultApi",
            "updateRoleApi",
            "createRoleApi",
            "queryRoleDetailMenuListApi",
            "queryRoleDetailMemberListApi",
            "updateRoleStateApi",
			"queryMultiTenantApi",
        ]),
        queryMenuTreeDefault() {
            this.queryMenuTreeDefaultApi().then(res => {
                let data = this.addFieldId(res);
                this.role.treeData = data
                this.role.details.treeData = data
                this.filterMenuId(data);
            })
        },
        onEmpListCurrentChange(val) {
            this.employee.form.pageNum = val
            this.queryEmployList();
        },
        onOrgCurrentChange(val) {
            this.organize.pageNum = val
            this.queryOrgMemberlist(this.organize.currOrgId);
        },
        addFieldId(res) {
            res.forEach(item => {
                item.id = item.menuId;
                if (item.children) {
                    this.addFieldId(item.children);
                }
            })
            return res;
        },
        onRoleDeletes() {
            if (this.role.multipleSelection.length == 0) {
                this.$message({
                    type: "warning",
                    message: "请勾选要删除的行",
                });
                return;
            }
            let targetIds = this.role.multipleSelection.map(i => i.roleId)
            this.deleteRoles(targetIds)
        },
        onRoleDelete(roleId) {
            this.deleteRoles([roleId])
        },
        onRoleSelectionChange(val) {
            this.role.multipleSelection = val
        },
        deleteRoles(targetIds) {
            this.$confirm("确定移除？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "error",
            })
                .then(() => {
                    this.deleteRoleApi({ targetIds: targetIds }).then(() => {
                        this.$message({
                            type: "success",
                            message: "删除成功",
                        });
                    });
                    this.queryRoleList();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        onRoleCheck(row) {
            this.role.details.roleId = row.roleId
            this.roleDetailsDialogVisible = true;
            this.queryRoleDetails(row.roleId);
        },
        queryRoleDetails(roleId) {
            this.queryRoleDetailMenuListApi(roleId).then(res => {
                let ids = res.map(i => i.menuId);
                this.$refs.roledetailTree.setCheckedKeys(ids)
            })
            this.queryRoleDetailMem();
        },
        queryRoleDetailMem() {
            let params = {
                roleId: this.role.details.roleId,
                pageSize: this.role.details.pageSize,
                pageNum: this.role.details.pageNum
            }
            this.queryRoleDetailMemberListApi(params).then(res => {
                this.role.details.tableData = res.rows.map(item => {
                    item.createTm = moment(item.createTm).format("YYYY-MM-DD HH:mm:ss");
                    return item;
                });
                this.role.details.totalCount = res.totalCount
                this.role.details.pageNum = res.pageNum
            })
        },
        onRoleDetailCurrentChange(val) {
            this.pageNum = val;
            this.queryRoleDetailMem()
        },
        onRoleCreate() {
            this.role.newRole.title = '新增角色'
            this.role.newRole.form.roleName = ''
            this.role.newRole.form.menuList = [];
            /* this.$refs.newRoleDialogFormItem.resetField(); */
            this.newRoleDialogFormVisible = true
        },
        eRoleAlterOpened() {
            this.$refs.roleMenutree.setCheckedKeys(this.role.newRole.form.menuList);
        },
        onRoleEdit(row) {
            this.role.newRole.title = '修改角色'
            this.role.newRole.form.roleName = row.roleName
            this.role.newRole.roleId = row.roleId
            let list = row.menuIds ? row.menuIds : []
            this.role.newRole.form.menuList = list.filter(item => this.filterMenuIds.indexOf(item)==-1)
            this.newRoleDialogFormVisible = true
        },
        filterMenuId(data){
            data.forEach(item => {
                if(item.children && item.children.length>0){
                    this.filterMenuIds.push(item.menuId)
                    this.filterMenuId(item.children)
                }
            });
        },
        onRoleFormSubmit() {
            this.$refs.newRoleDialogForm.validate((valid) => {
                if (valid) {
                    let params = this.role.newRole.form
                    let methodname;
                    let message;
                    params.menuList = this.$refs.roleMenutree.getCheckedKeys()
                    if (this.role.newRole.title == '新增角色') {
                        methodname = 'createRoleApi'
                        message = '创建成功'
                    } else {
                        methodname = 'updateRoleApi'
                        params.roleId = this.role.newRole.roleId
                        message = '修改成功'
                    }
                    this[methodname](params).then(res => {
                        this.$message({
                            type: 'success',
                            message: message
                        });
                        this.newRoleDialogFormVisible = false;
                        this.queryRoleList();
                    }).catch(e => { });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        onRoleState(row) {
            let action = row.state == 1 ? '禁用' : '启用';
            this.$confirm(`确定${action}该角色？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let param = {
                        roleId: row.roleId,
                        state: row.state == 1 ? 2 : 1
                    };
                    this.updateRoleStateApi(param).then(() => {
                        this.$message({
                            type: "success",
                            message: "修改成功",
                        });
                        this.queryRoleList();
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消修改",
                    });
                });
        },
        onDeleteOrg(data) {
            this.$confirm("确定移除？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "error",
            })
                .then(() => {
                    let orgId = data.id;
                    this.removeOrgApi({ orgId: orgId }).then(() => {
                        this.$message({
                            type: "success",
                            message: "移除成功",
                        });
                        this.queryOrgTree();
                        if (orgId == this.organize.currOrgId) {
                            this.organize.tableData = [];
                            this.organize.multipleSelection = [];
                            this.organize.pageNum = 1;
                            this.organize.total = 0;
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        onAddOrgMems() {
            let orgId = this.organize.currOrgId
            if (!orgId) {
                this.$message({
                    type: 'warning',
                    message: '请选择要添加的组织'
                })
                return;
            }
            this.addMemDialogFormVisible = true
            this.queryOrgExMemberList(orgId)
        },
        onEnterSearchMems() {
            let orgId = this.organize.currOrgId
            this.queryOrgExMemberList(orgId)
        },
        onHandleSelectionChange(val) {
            this.organize.emp.multipleSelection = val;
        },
        onAddOrgMemsconfirm() {
            let memberIdList = this.organize.emp.multipleSelection;
            if (memberIdList.length == 0) {
                this.$message({
                    type: "warning",
                    message: "请勾选要添加的员工",
                });
                return;
            }
            memberIdList = memberIdList.map(item => item.memberId)
            let params = {
                orgId: this.organize.currOrgId,
                memberIdList: memberIdList
            }
            this.addMemsToOrgApi(params).then(res => {
                this.$message({
                    type: "success",
                    message: "添加成功",
                });
                this.addMemDialogFormVisible = false
                this.queryOrgTree();
                this.queryOrgMemberlist(this.organize.currOrgId)
            })
        },

        queryOrgExMemberList(orgId) {
            let params = Object.assign({}, this.organize.emp.form)
            params.orgId = orgId
            this.getOrgExMemberApi(params).then(res => {
                this.organize.emp.tableData = res.rows
                this.organize.emp.form.pageSize = res.pageSize
                this.organize.emp.totalCount = res.totalCount
            })
        },
        removeOrgMembers(memberIdList, orgId) {
            this.$confirm("确定移除？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "error",
            })
                .then(() => {
                    this.removeMembersApi({ memberIdList: memberIdList, orgId: orgId }).then(() => {
                        this.$message({
                            type: "success",
                            message: "移除成功",
                        });
                    });
                    this.queryOrgTree();
                    this.queryOrgMemberlist(this.organize.currOrgId)
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        onOrgRemoveMems() {
            let memberIdList = this.organize.multipleSelection;
            let orgId = this.organize.currOrgId
            if (memberIdList.length == 0) {
                this.$message({
                    type: "warning",
                    message: "请勾选要删除的行",
                });
                return;
            }
            memberIdList = memberIdList.map(item => item.memberId)
            this.removeOrgMembers(memberIdList, orgId)
        },
        orgTableChange(val) {
            this.organize.multipleSelection = val;
        },
        onOrgRemoveMem(id) {
            let orgId = this.organize.currOrgId
            this.removeOrgMembers([id], orgId)
        },
        getOrgList() {
            let keys = this.$refs.employee_news_tree.getCheckedKeys()
            let nodes = this.$refs.employee_news_tree.getCheckedNodes()
            this.employee.news.form.orgIdList = keys
            this.employee.news.form.orgStr = nodes.map(i => i.label).join(',')
            this.employee.news.orgVisible = false;
        },
        onCreateEmployeeOpen() {
            this.newMemDialogFormVisible = true
			this.isMultiTenant = false
			this.employee.news.currUserId = null;
            this.employee.news.title = "新增员工"
            this.employee.news.form.userName = ''
            this.employee.news.form.telephone = ''
            this.employee.news.form.identity = ''
            this.employee.news.form.roleStr = ''
            this.employee.news.form.orgStr = ''
            this.employee.news.form.powerStr = ''
            this.employee.news.form.roleIdList = []
            this.employee.news.form.orgIdList = []
            this.employee.news.form.powerList = []
        },
        onEmployFormSubmit() {
            this.$refs.newMemDialogForm.validate((valid) => {
                if (valid) {
                    let params = Object.assign({}, this.employee.news.form)
                    let methodname;
                    let message;
                    if (this.employee.news.title == '新增员工') {
                        methodname = 'createEmployeeApi'
                        message = '创建成功'
						if(this.employee.news.currUserId){
							params.userId = this.employee.news.currUserId
						}
                        delete params.memberId
                    } else {
                        params.userId = this.employee.news.currUserId
                        methodname = 'alterEmployInfoApi'
                        message = '修改成功'
                    }
                    this[methodname](params).then(res => {
                        this.$message({
                            type: 'success',
                            message: message
                        });
                        this.newMemDialogFormVisible = false;
                        this.queryEmployList();
                    }).catch(e => { });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        oncloseOrgPopup() {
            this.$refs.newOrgDialogForm.resetFields();
        },
        onOrgFormconfirm() {
            this.$refs.newOrgDialogForm.validate((valid) => {
                if (valid) {
                    let params = Object.assign({}, this.organize.neworg.form)
                    let methodname;
                    let message;
                    if (this.organize.neworg.title == '新增组织') {
                        methodname = 'createOrgApi'
                        message = '创建成功'
                    } else {
                        methodname = 'updateOrgApi'
                        message = '修改成功'
                        delete params.parentId
                        params.orgId = this.organize.neworg.form.parentId
                    }
                    this[methodname](params).then(res => {
                        this.$message({
                            type: 'success',
                            message: message
                        });
                        this.newOrgDialogFormVisible = false;
                        this.queryOrgTree();
                    }).catch(e => { });

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        eSelectRoleOpened() {
            this.getRoleListApi({}).then(res => {
                this.employee.news.checkbox.options = res;
                let optionHash = {};
                res.forEach(item => {
                    optionHash[item.roleId] = item.roleName
                });
                this.employee.news.checkbox.optionHash = optionHash
                this.employee.news.checkbox.checkeds = this.employee.news.form.roleIdList
            });
        },
        eSelectOrgOpened() {
            this.getOrgTreeApi().then(res => {
                this.employee.news.tree.data = [res]
                /* let ids = this.employee.news.form.orgIdList
                this.$refs.employee_news_tree.setCheckedKeys(ids) */
            });
        },
        eSelectPowerOpened() {
            this.getOrgTreeApi().then(res => {
                this.employee.news.tree.powerTree = [res];
                let ids = this.employee.news.form.powerList
                this.$refs.employee_news_powertree.setCheckedKeys(ids)
            });
        },
        splitString(str) {
            return str ? str.replace(/,/g, "<br>") : '';
        },
        orgFilterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        queryOrgTree() {
            this.getOrgTreeApi().then(res => {
                this.organize.treeData = this.changeLabel([res])
            });
        },
        changeLabel(arr) {
            arr.forEach(item => {
                item.label = item.label + '（' + item.memberNum + '）'
                if (item.children) {
                    this.changeLabel(item.children)
                }
            })
            return arr;
        },
        onTabsClick(tab) {
            let label = tab.label
            if (label == '组织管理') {
                this.queryOrgTree()
            } else if (label == '员工管理') {
                this.queryEmployList();
            } else {
                this.queryRoleList();
            }
        },
        onCreateOrg(data) {
            this.organize.neworg.form.parentId = data.id
            this.organize.neworg.title = '新增组织'
            this.newOrgDialogFormVisible = true
        },
        onAlterOrg(data) {
            this.organize.neworg.form.parentId = data.id
            this.organize.neworg.title = '修改组织'
            this.newOrgDialogFormVisible = true
            this.organize.neworg.form.orgName = this.doFilter(data.label)
            this.organize.neworg.form.orgType = 1
            this.organize.neworg.form.num = data.num
        },
        doFilter(label) {
            return label.split('（')[0]
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        handleSizeChange() { },
        handleCurrentChange() { },
        role_currChange(val){
            this.role.pageNum = val;
            this.queryRoleList();
        },
        org_addMem_currChange(val){
            this.organize.emp.form.pageNum = val;
            let orgId = this.organize.currOrgId
            this.queryOrgExMemberList(orgId)
        },
        onQueryUserList() {
            this.queryEmployList();
        },
        queryEmployList() {
            let param = Object.assign(
                { tenantId: this.tenantId },
                this.employee.form
            );
            this.getEmployeeListApi(param).then(res => {
                this.employee.tableData = res.rows.map((item) => {
                    item.createTm = moment(item.createTm).format("YYYY-MM-DD HH:mm:ss");
                    item.stateName = item.state == "1" ? "启用" : "禁用";
                    return item;
                });
                this.employee.pageNum = res.pageNum;
                this.employee.totalCount = res.totalCount;
            }).catch(e => { });
        },
        onQueryRoleList() {
            this.queryRoleList();
        },
        queryRoleList() {
            let params = this.role.form
            params.pageNum = this.role.pageNum
            params.pageSize = this.role.pageSize
            this.getRoleListSummaryApi(params).then(res => {
                this.role.tableData = res.rows.map((item) => {
                    item.createTm = moment(item.createTm).format("YYYY-MM-DD HH:mm:ss");
                    item.stateName = item.state == "1" ? "启用" : "禁用";
                    return item;
                });
                this.role.pageNum = res.pageNum;
                this.role.totalCount = res.totalCount;
            }).catch(e => { });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        removeOrg() {
            /* node, data */
        },
        editOrg() {
            /* node, data */
        },
        onNodeClick(data) {
            this.queryOrgMemberlist(data.id)
        },
        queryOrgMemberlist(id) {
            let params = {
                orgId: id,
                pageNum: this.organize.pageNum,
                pageSize: this.organize.pageSize
            }
            this.getOrgQueryMembersApi(params).then(res => {
                this.organize.tableData = res.rows
                this.organize.total = res.totalCount
                this.organize.pageNum = res.pageNum
                this.organize.currOrgId = id
            })
        },
        employeeCheckDetail(row) {
            debugger
            this.employeeDetailsDialogVisible = true;
            let detail = this.employee.details;
            detail.name = row.userName;
            detail.phone = row.telephone;
            detail.certId = row.identity;
            detail.role = row.roleName;
            detail.org = row.orgName;
            detail.power = row.powerName;
            detail.state = row.stateName;
            detail.createTime = row.createTm;
            detail.phoneDto = row.telephoneDto;
            detail.certIdDto = row.identityDto;
        },
        onEmployeeEditOpen(row) {
            this.newMemDialogFormVisible = true;
			this.isMultiTenant = false
            this.employee.news.title = '编辑员工'
            this.employee.news.currUserId = row.userId
            this.employee.news.form.userName = row.userName
            this.employee.news.form.telephone = row.telephone
            this.employee.news.form.identity = row.identity
            this.employee.news.form.memberId = row.memberId

            this.employee.news.form.roleStr = row.roleName
            this.employee.news.form.orgStr = row.orgName
            this.employee.news.form.powerStr = row.powerName
            this.employee.news.form.roleIdList = row.roleList.map(i => i.roleId)
            this.employee.news.form.orgIdList = row.orgList.map(i => i.orgId)
            this.employee.news.form.powerList = row.powerList.map(i => i.orgId)
            decrypt(row.telephoneDto.encStr).then(res => {
                this.employee.news.form.telephone = res
            })
            decrypt(row.identityDto.encStr).then(res => {
                this.employee.news.form.identity = res
            })
        },
        employeeStateAlter(row) {
            let action = row.state == 1 ? '禁用' : '启用';
            this.$confirm(`确定${action}该员工？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let param = {
                        memberId: row.memberId
                    };
                    let methodname = row.state == 1 ? 'disableMemberApi' : 'enableMemberApi';
                    this[methodname](param).then(() => {
                        this.$message({
                            type: "success",
                            message: "修改成功",
                        });
                        this.queryEmployList();
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消修改",
                    });
                });
        },
        onEmployeeDelete(id) {
            this.employeeDelete([id])
        },
        onEmployeeDeletes() {
            if (this.employee.multipleSelection.length == 0) {
                this.$message({
                    type: "warning",
                    message: "请勾选要删除的行",
                });
                return;
            }
            let targetIds = this.employee.multipleSelection.map(item => item.memberId)
            this.employeeDelete(targetIds)
        },
        employeeTableChange(val) {
            this.employee.multipleSelection = val;
        },
        checkboxInit(row) {
            if (row.userId == this.userId) {
                return 0
            } else {
                return 1
            }
        },
        checkboxInitRole(row) {
            if (row.roleType == 1) {
                return 0
            } else {
                return 1
            }
        },
        employeeDelete(targetIds) {
            this.$confirm("确定移除员工？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "error",
            })
                .then(() => {
                    let params = { targetIds: targetIds };
                    this.removeEmployeesApi(params).then(() => {
                        this.$message({
                            type: "success",
                            message: "移除成功",
                        });
                    });
                    this.queryEmployList();

                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        onSelectRolesConfirm() {
            let checkeds = this.employee.news.checkbox.checkeds
            this.employee.news.form.roleIdList = checkeds
            let optionHash = this.employee.news.checkbox.optionHash
            let names = this.reflectNames(checkeds, optionHash)
            this.employee.news.form.roleStr = names
            this.employee.news.roleVisible = false
        },
        onSelectPowersConfirm() {
            let checkeds = this.$refs.employee_news_powertree.getCheckedKeys()
            let names = this.$refs.employee_news_powertree.getCheckedNodes().map(i => i.label).join(',')
            this.employee.news.form.powerList = checkeds
            this.employee.news.form.powerStr = names
            this.employee.news.powerVisible = false
        },
        onSelectOrgsConfirm() {
            let checkeds = this.$refs.employee_news_tree.getCheckedKeys()
            let names = this.$refs.employee_news_tree.getCheckedNodes().map(i => i.label).join(',')
            this.employee.news.form.orgIdList = checkeds
            this.employee.news.form.orgStr = names
            this.employee.news.orgVisible = false
        },
        reflectNames(checkdeds, optionHash) {
            return checkdeds.map(item => {
                return optionHash[item]
            }).join(',')
        },

        roleCheckDetail() {
            this.roleDetailsDialogVisible = true;
        },
        roleEdit() { },
        roleStateAlter() {
            this.$confirm("确定禁用该角色？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "修改成功",
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消修改",
                    });
                });
        },
        roleDelete() {
            this.$confirm("确定移除该角色？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "error",
            })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "移除成功",
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },

        orgDeleteEmployee() {
            this.$confirm("确定移除员工？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "error",
            })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "移除成功",
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
		queryMultiTenant(){
			if(this.employee.news.title != '新增员工'){
				return;
			}
			if(this.employee.news.form.userName&&this.employee.news.form.telephone){
				    let param = {userName:this.employee.news.form.userName,telephone:this.employee.news.form.telephone};
				    this.queryMultiTenantApi(param).then(res => {
						if(res&&res.tenantName){
							this.employee.news.currUserId = res.userId;
							this.tenantNameText = res.tenantName;
							this.isMultiTenant = true;
						}else{
							this.employee.news.currUserId = null;
							this.tenantNameText = null;
							this.isMultiTenant = false;
						}
					}).catch(e => { });
			}
		}
    },
    created() {
        let map = JSON.parse(sessionStorage.getItem('menuMap'))
        let submenuList = map['PowerManager'].split('-');
        submenuList.forEach((item, idex) => {
            this.show[item] = true;
            idex == 0 && (this.activeTab = item)
        })
    },
    mounted() {
        this.queryOrgTree();
        this.queryMenuTreeDefault();
        this.queryRoleList();
        this.queryEmployList();
    },
    computed: {
        tenantId: function () {
            return this.$store.state.login.tenantId;
        },
        userId: function () {
            return this.$store.state.login.userId;
        },
        orgFilterText() {
            return this.organize.filterText
        },

    },
    watch: {
        orgFilterText(val) {
            this.$refs.orgFilterTree.filter(val)
        },
    }
};